import React from "react";

import * as actions from "../actions/actions";
import { connect } from "react-redux";

import number_with_commas from "../legacy/helpers/number_with_commas";

import Loading from "./loading";
import classnames from "classnames";

import { Link } from "react-router-dom";
import { PUBLIC_PROFILE } from "../data/links";

class SearchInfoBar extends React.Component {
    static propTypes = {};

    renderResultsFor() {
        return (
            <h3 className="search-title font-medium weight-light">
                {`Results for “${this.props.query}”`}
            </h3>
        );
    }

    renderDidYouMean() {
        let didYouMean, didYouMeanLink;

        if (this.props.didYouMean) {
            if (this.props.searchType === "collections") {
                // If we are searching for collections, stay there
                didYouMeanLink = `/search/collection/?q=${this.props.didYouMean}`;
            } else {
                // Otherwise we are searching all icons
                didYouMeanLink = `/search/?q=${this.props.didYouMean}`;
            }

            // If there is a scope, make sure the links are right
            switch (this.props.scope) {
                case "creator":
                    didYouMeanLink = `/search/?q=${this.props.didYouMean}&creator=${this.props.scope_id}`;
                    break;
                case "collection":
                    didYouMeanLink = `/search/?q=${this.props.didYouMean}&collection=${this.props.scope_id}`;
                    break;
            }
            let linkTestId = "suggestion-link";
            let linkClassName = "text-link color-black";
            let didYouMeanComponent;

            if (this.props.searchType == "collections") {
                // Collectionlist doesn't use router yet
                didYouMeanComponent = (
                    <a
                        data-test-id={linkTestId}
                        className={linkClassName}
                        href={didYouMeanLink}
                    >
                        {this.props.didYouMean}
                    </a>
                );
            } else {
                didYouMeanComponent = (
                    <Link
                        data-test-id={linkTestId}
                        className={linkClassName}
                        to={didYouMeanLink}
                    >
                        {this.props.didYouMean}
                    </Link>
                );
            }

            didYouMean = (
                <span>
                    Did you mean {didYouMeanComponent}
                    {"?"}
                </span>
            );
        } else {
            didYouMean = <span>&nbsp;</span>;
        }

        return didYouMean;
    }

    renderSearchEverything() {
        if (!this.props.scope) {
            // Don't render if there is a scope
            return null;
        }

        return (
            <a
                className="text-link weight-medium"
                href="#"
                onClick={this.searchEverything.bind(this)}
            >
                Search all icons
            </a>
        );
    }

    renderResultsNavigation() {
        // If we are scoped (looking at search within collection or creator) then show the scope contextual text instead
        if (this.props.scope) {
            return this.renderScopeText();
        } else {
            return this.renderResultsNavigationLinks();
        }
    }

    renderResultsNavigationLinks() {
        let iconStyle, collectionStyle, photosStyle;

        if (this.props.searchType === "icons") {
            iconStyle = {
                pointerEvents: "none"
            };
            collectionStyle = {
                pointerEvents: "inherit"
            };
            photosStyle = {
                pointerEvents: "inherit"
            };
        } else {
            iconStyle = {
                pointerEvents: "inherit"
            };
            collectionStyle = {
                pointerEvents: "none"
            };
            photosStyle = {
                pointerEvents: "inherit"
            };
        }

        if (!this.props.counts) {
            return null;
        }

        return (
            <ul className="search-navigation pill-tab-container margin-t-m">
                <li>
                    <a
                        className={
                            this.props.searchType !== "icons"
                                ? "pill-tab-first pill-tab"
                                : "pill-tab-first pill-tab pill-tab-selected"
                        }
                        href={`/search/?q=${this.props.query}`}
                        style={iconStyle}
                    >
                        {number_with_commas(this.props.counts.icons)}{" "}
                        {this.props.counts.icons === 1 ? "icon" : "icons"}
                    </a>
                </li>
                <li>
                    <a
                        className={
                            this.props.searchType !== "collections"
                                ? "pill-tab"
                                : "pill-tab pill-tab-selected"
                        }
                        href={`/search/collection/?q=${this.props.query}`}
                        style={collectionStyle}
                    >
                        {number_with_commas(this.props.counts.collections)}{" "}
                        {window.innerWidth <= 425 ? " " : "icon "}
                        {this.props.counts.collections === 1
                            ? "collection"
                            : "collections"}
                    </a>
                </li>
                <li>
                    <a
                        className={"pill-tab-last pill-tab"}
                        href={`/search/photos/?q=${this.props.query}`}
                        style={photosStyle}
                    >
                        {number_with_commas(this.props.counts.photos)}{" "}
                        {this.props.counts.photos === 1 ? "photo" : "photos"}
                    </a>
                </li>
            </ul>
        );
    }

    renderScopeText() {
        let scopeNavigationText;

        if (this.props.scope === "collection") {
            let collectionName =
                this.props.collection.name
                    .toLowerCase()
                    .indexOf("collection") >= 1
                    ? this.props.collection.name
                    : this.props.collection.name + " Collection";
            scopeNavigationText = (
                <span className="color-grey">
                    in{" "}
                    <a
                        className="text-link"
                        style={{
                            textTransform: "capitalize"
                        }}
                        href={`${this.props.collection.permalink}/`}
                    >
                        {collectionName}
                    </a>
                </span>
            );
        } else if (this.props.scope === "creator") {
            scopeNavigationText = (
                <span className="color-grey">
                    created by{" "}
                    <a
                        className="text-link"
                        href={PUBLIC_PROFILE.replace(
                            ":username",
                            encodeURIComponent(this.props.creator.username)
                        )}
                    >
                        {this.props.creator.name}
                    </a>
                </span>
            );
        }
        return (
            <div className="scope-navigation  margin-t-s">
                {scopeNavigationText}
            </div>
        );
    }

    searchEverything(e) {
        e.preventDefault();

        window.location = `/search/?q=${this.props.query}`;
    }

    render() {
        let infobarContent = (
            // Loading state by default
            <div className="infobar-content" style={{ height: "64px" }} />
        );

        let content;
        if (!this.props.processing) {
            content = (
                <>
                    <div className="left-navigation">
                        {this.renderResultsFor()}
                        {this.renderResultsNavigation()}
                    </div>

                    <div
                        className="right-navigation"
                        style={{ textAlign: "right" }}
                    >
                        <h3 className="suggestion-title color-black font-medium weight-light">
                            {this.renderDidYouMean()}
                        </h3>
                        <div className="margin-t-s color-grey">
                            {this.renderSearchEverything()}
                        </div>
                    </div>
                </>
            );
        }
        if (this.props.query) {
            // If there is a query, fill in the content
            let infobarClass = classnames("infobar-content", {
                processing: this.props.processing,
                [`scope-${this.props.scope}`]: this.props.scope
            });
            infobarContent = <div className={infobarClass}>{content}</div>;
        }

        return (
            <section className="bg-offwhite padding-t-m padding-b-m margin-t-none">
                <div className="container">{infobarContent}</div>
            </section>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let infoContainer = state.icons;

    if (ownProps.searchType == "collections") {
        let { queryInfo } = state.search;
        infoContainer = queryInfo || {};
    }

    let {
        counts,
        creator,
        collection,
        scope,
        scope_id,
        processing
    } = infoContainer;

    let derivedProps = {
        counts,
        creator,
        collection,
        scope,
        scope_id,
        processing
    };

    if (ownProps.searchType == "collections") {
        derivedProps.query = infoContainer.query;
    }
    return derivedProps;
}

export default connect(mapStateToProps, {})(SearchInfoBar);
